import { render, staticRenderFns } from "./RegistrationStep4.vue?vue&type=template&id=762cdbf6&scoped=true"
import script from "./RegistrationStep4.vue?vue&type=script&lang=js"
export * from "./RegistrationStep4.vue?vue&type=script&lang=js"
import style0 from "./RegistrationStep4.vue?vue&type=style&index=0&id=762cdbf6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "762cdbf6",
  null
  
)

export default component.exports